<div class="form-options">
  <div class="form-options__title">{{ "campaign.widget.sidebar.form-settings.settings" | translate }}</div>

  <div class="form-options-card form-options-card--row">
    <mat-slide-toggle class="form-options-toggle" [(ngModel)]="isPartialStepsActivated" [disabled]="savingPartialSteps" (change)="togglePartialSteps()">
      {{ "campaign.widget.sidebar.form-settings.partial-form" | translate }}
    </mat-slide-toggle>
    <mat-icon class="form-options-info" [matTooltip]="'explainer.form-settings.partial-form-warn.description' | translate">info_outline</mat-icon>
  </div>

  <div class="form-options-card">
    <div class="form-options-oneq__header" (click)="toggleExpandSlideInForm($event)">
      <mat-slide-toggle
        class="form-options-toggle"
        [(ngModel)]="isSplitInputsToStepsActivated"
        [disabled]="!isSplitInputsToStepsPossible || savingSplitInputsToSteps"
        [matTooltip]="'campaign.widget.sidebar.form-settings.one-question-at-a-time-errors.' + isSplitInputsToStepsPossibleError | translate"
        [matTooltipDisabled]="isSplitInputsToStepsPossible"
        (change)="toggleSplitInputsToSteps()">
        {{ "campaign.widget.sidebar.form-settings.one-question-at-a-time" | translate }}
      </mat-slide-toggle>
      <div class="form-options-spacer"></div>
      <mat-icon class="form-options-chevron">{{ slideInFormIsExpanded ? "expand_less" : "expand_more" }}</mat-icon>
    </div>
    <div class="form-options-oneq__descr">
      {{ "campaign.widget.sidebar.form-settings.one-question-at-a-time-descr" | translate }}
    </div>

    @if (slideInFormIsExpanded) {
      <div class="form-options-oneq__body" @expandReveal>
        <p class="form-options-note" [innerHtml]="'campaign.widget.sidebar.form-settings.one-question-at-a-time-note' | translate"></p>

        <div class="form-options-field-row">
          <div class="form-options-field__label" [class.form-options-disabled]="isPropertySlideInDisabled">
            {{ "campaign.widget.sidebar.form-settings.label-to-next-btn" | translate }}
          </div>
          <mat-form-field class="form-options-field" appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              type="text"
              [(ngModel)]="configSlideIn.selectedSlidingFormLabelName"
              [disabled]="isPropertySlideInDisabled"
              [placeholder]="'campaign.widget.sidebar.form-settings.label-to-next-btn' | translate"
              (change)="updateSlidingFormProgressStyle()" />
          </mat-form-field>
        </div>

        <div class="form-options-field-row">
          <div class="form-options-field__label" [class.form-options-disabled]="isPropertySlideInDisabled">
            {{ "campaign.widget.sidebar.form-settings.sliding-form-styles-select" | translate }}
          </div>
          <mat-form-field class="form-options-field" appearance="outline" subscriptSizing="dynamic">
            <mat-select
              [(ngModel)]="configSlideIn.selectedSlidingFormProgressStyle"
              [disabled]="isPropertySlideInDisabled"
              (ngModelChange)="updateSlidingFormProgressStyle()">
              @for (item of slidingFormProgressStyles; track item.key) {
                <mat-option [value]="item.key">{{ item.value | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Shortcuts to add the buttons stepping requires, shown only when they're what's missing. -->
        @if (!isSplitInputsToStepsActivated && !isSplitInputsToStepsPossible) {
          @if (isSplitInputsToStepsPossibleError === "one-submit-button") {
            <div class="form-options-add">
              <div class="form-options-add__warn">
                <mat-icon>warning</mat-icon>
                {{ "campaign.widget.sidebar.form-settings.submit-btn-missing" | translate }}
              </div>
              <button mat-stroked-button class="secondary-button" (click)="addButton('submit-btn')">
                {{ "campaign.widget.sidebar.form-settings.add-submit-button" | translate | uppercase }}
              </button>
            </div>
          }
          @if (backButtonComponents.length !== 1) {
            <div class="form-options-add">
              <div class="form-options-add__warn">
                <mat-icon>warning</mat-icon>
                {{ "campaign.widget.sidebar.form-settings.back-btn-missing" | translate }}
              </div>
              <button mat-stroked-button class="secondary-button" (click)="addButton('back-btn')">
                {{ "campaign.widget.sidebar.form-settings.add-back-button" | translate | uppercase }}
              </button>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
